import React from 'react'
import * as styles from './field-error.module.css'
import { sentenceCase } from '@cinch/design-system/src/components/forms/utils'
import cx from 'classnames'
import { ClassNamesApiProps } from '@cinch/design-system/src/components/types'

export interface FormFieldErrorClassNameProps {
  container?: string
  icon?: string
  message?: string
}

export interface FormFieldErrorProps extends ClassNamesApiProps<FormFieldErrorClassNameProps> {
  show: boolean
  collapse?: boolean
  message?: string
}

const FormFieldError: React.FC<FormFieldErrorProps> = ({ show = false, collapse = false, message, classNames }) => {
  if (show && message) {
    return (
      <div
        className={cx(styles.error, classNames?.container)}
        role="presentation"
        data-testid="FormFieldError/Container"
      >
        <span className={cx(styles.icon, classNames?.icon)} role="img" data-testid="FormFieldError/Icon">
          <svg
            id="Component_3_2"
            data-name="Component 3 – 2"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <circle id="Ellipse_11" data-name="Ellipse 11" cx="6" cy="6" r="6" fill="#df002a" />
            <path
              id="Line_4_Copy_3"
              data-name="Line 4 Copy 3"
              d="M5.77,6.431,3.289,3.919.809,6.431a.472.472,0,0,1-.663-.672l2.48-2.512L.229.819A.472.472,0,1,1,.893.148l2.4,2.428L5.686.148a.472.472,0,0,1,.663.672l-2.4,2.428,2.48,2.512a.481.481,0,0,1-.336.82A.455.455,0,0,1,5.77,6.431Z"
              transform="translate(2.52 2.861)"
              fill="#fff"
            />
          </svg>
        </span>
        <span className={cx(styles.message, classNames?.message)} role="alert" data-testid="FormFieldError/Message">
          {sentenceCase(message)}
        </span>
      </div>
    )
  } else if (!collapse) {
    return (
      <div
        className={cx(styles.error, classNames?.container)}
        role="presentation"
        data-testid="FormFieldError/Container"
      >
        &nbsp;
      </div>
    )
  }

  return null
}

export default FormFieldError
